import { render } from "./projects.vue?vue&type=template&id=037d3602&scoped=true"
import script from "./projects.vue?vue&type=script&lang=ts"
export * from "./projects.vue?vue&type=script&lang=ts"

import "./projects.vue?vue&type=style&index=0&id=037d3602&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-037d3602"

export default script